export default __webpack_public_path__ + "media/img_01/600@2x-13eb4ead.jpg";